export const actionTypes = {
    BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE: 'BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE',
    BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE: 'BREADCRUMB_CHANGED_ON_CERTIFICATES_CONTENT_PAGE',
    BREADCRUMB_CHANGED_ON_CERTIFICATES_PAGE: 'BREADCRUMB_CHANGED_ON_CERTIFICATES_PAGE',
    BREADCRUMB_CHANGED_ON_COMPETENCES_CONTENT_PAGE: 'BREADCRUMB_CHANGED_ON_COMPETENCES_CONTENT_PAGE',
    BREADCRUMB_CHANGED_ON_COMPETENCES_PAGE: 'BREADCRUMB_CHANGED_ON_COMPETENCES_PAGE',
    BREADCRUMB_CHANGED_ON_NEWS_LIST_PAGE: 'BREADCRUMB_CHANGED_ON_NEWS_LIST_PAGE',
    BREADCRUMB_CHANGED_ON_NEWS_PAGE: 'BREADCRUMB_CHANGED_ON_NEWS_PAGE',
    FETCH_CERTIFICATES_ITEMS_COMPLETED: 'FETCH_CERTIFICATES_ITEMS_COMPLETED',
    FETCH_COMPETENCES_ITEMS_COMPLETED: 'FETCH_COMPETENCES_ITEMS_COMPLETED',
    FETCH_CONTENT_PAGE_BY_ID_COMPLETED: 'FETCH_CONTENT_PAGE_BY_ID_COMPLETED',
    FETCH_CONTENT_PAGE_ERROR: 'FETCH_CONTENT_PAGE_ERROR',
    FETCH_EVENT_CATEGORIES_COMPLETED: 'FETCH_EVENT_CATEGORIES_COMPLETED',
    FETCH_EVENT_ITEMS: 'FETCH_EVENT_ITEMS',
    FETCH_EVENT_ITEM_BY_ID_COMPLETED: 'FETCH_EVENT_ITEM_BY_ID_COMPLETED',
    FETCH_FOOTER_COMPLETED: 'FETCH_FOOTER_COMPLETED',
    FETCH_NEWS_CATEGORIES_COMPLETED: 'FETCH_NEWS_CATEGORIES_COMPLETED',
    FETCH_NEWS_ITEMS: 'FETCH_NEWS_ITEMS',
    FETCH_NEWS_ITEM_BY_ID_COMPLETED: 'FETCH_NEWS_ITEM_BY_ID_COMPLETED',
    FETCH_TOPIC_ITEMS: 'FETCH_TOPIC_ITEMS',
    FETCH_TOP_NAVIGATION_COMPLETED: 'FETCH_TOP_NAVIGATION_COMPLETED',
    FETCH_WELCOME_PAGE_HERO_BANNER_COMPLETED: 'FETCH_WELCOME_PAGE_HERO_BANNER_COMPLETED',
    FETCH_WELCOME_PAGE_HIGHLIGHT_MAIN_ITEMS_COMPLETED: 'FETCH_WELCOME_PAGE_HIGHLIGHT_MAIN_ITEMS_COMPLETED',
    FETCH_WELCOME_PAGE_HIGHLIGHT_SUB_MAIN_ITEMS_COMPLETED: 'FETCH_WELCOME_PAGE_HIGHLIGHT_SUB_MAIN_ITEMS_COMPLETED',
    FETCH_WELCOME_PAGE_NEWS_ITEMS_COMPLETED: 'FETCH_WELCOME_PAGE_NEWS_ITEMS_COMPLETED',
    HTTP_CALL_END: 'HTTP_CALL_END',
    HTTP_CALL_START: 'HTTP_CALL_START',
    MOBILE_NAVIGATION_CLICKED: 'MOBILE_NAVIGATION_CLICKED',
    SEARCH_COMPLETED: 'SAVE_MEMBER',
    SET_COOKIE_BANNER_VISIBILITY: 'SET_COOKIE_BANNER_VISIBILITY',
    SET_TOP_NAVIGATION_ACTIVE_CSS: 'SET_TOP_NAVIGATION_ACTIVE_CSS',
    UPDATE_MOBILE_SUB_NAVIGATION: 'UPDATE_MOBILE_SUB_NAVIGATION'    
  };


// WEBPACK FOOTER //
// ./src/common/constants/actionTypes.ts